import { render, staticRenderFns } from "./AiMonthReportPromptTemplateEdit.vue?vue&type=template&id=2e0aee96&"
import script from "./AiMonthReportPromptTemplateEdit.vue?vue&type=script&lang=ts&"
export * from "./AiMonthReportPromptTemplateEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports